import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
interface MyStreamWaveMyVoteVotesProps {
  readonly drop: ExtendedDrop;
  readonly winningThreshold?: number | null | undefined;
}
const MyStreamWaveMyVoteVotes: React.FC<MyStreamWaveMyVoteVotesProps> = t0 => {
  const $ = _c(12);
  const {
    drop,
    winningThreshold
  } = t0;
  const voteClass = drop.rating >= 0 ? "tw-text-emerald-500" : "tw-text-rose-500";
  const hasWinningThreshold = typeof winningThreshold === "number" && winningThreshold > 0;
  const t1 = `tw-font-mono tw-text-sm tw-font-bold tw-tracking-tight ${voteClass}`;
  let t2;
  if ($[0] !== drop.rating) {
    t2 = formatNumberWithCommas(drop.rating);
    $[0] = drop.rating;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = hasWinningThreshold ? drop.realtime_rating : drop.rating_prediction;
  const t5 = hasWinningThreshold ? "Votes given now" : undefined;
  let t6;
  if ($[5] !== drop.rating || $[6] !== t4 || $[7] !== t5) {
    t6 = <DropVoteProgressing current={drop.rating} projected={t4} tooltipLabel={t5} />;
    $[5] = drop.rating;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-x-1.5">{t3}{t6}</div>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default MyStreamWaveMyVoteVotes;